// Guarantee Page

const buttons = Array.from(document.querySelectorAll('.js-style-button')),
      images = Array.from(document.querySelectorAll('.js-style-image'));

var slideIndex = 0;

buttons[0].closest('.js-style-slide').classList.add('style-slides__slide--active');
images[0].classList.add('style-slides__image--active');

// Call thongSlider function on click
buttons.forEach((elem) => {
  elem.addEventListener('click', thongSlider);
});

// Style slider
function thongSlider(e) {
  let btn = e.target,
      nextIndex = buttons.indexOf(btn),
      nextImg = images[nextIndex],
      prevImg = images[slideIndex];

  if (nextIndex !== slideIndex) {

    if (nextIndex > slideIndex) {

      nextImg.addEventListener('animationend', () => {
        nextImg.classList.add('style-slides__image--active');
        prevImg.classList.remove('style-slides__image--active');
        nextImg.classList.remove('fadeInUp');
        prevImg.classList.remove('fadeOutUp');
      }, {once: true});
  
      nextImg.classList.add('fadeInUp');
      prevImg.classList.add('fadeOutUp');
  
    } else {

      nextImg.addEventListener('animationend', () => {
        nextImg.classList.add('style-slides__image--active');
        prevImg.classList.remove('style-slides__image--active');
        nextImg.classList.remove('fadeInDown');
        prevImg.classList.remove('fadeOutDown');
      }, {once: true});
  
      nextImg.classList.add('fadeInDown');
      prevImg.classList.add('fadeOutDown');
  
    }
  
    btn.closest('.js-style-slide').classList.add('style-slides__slide--active');
    buttons[slideIndex].closest('.js-style-slide').classList.remove('style-slides__slide--active');
    slideIndex = nextIndex;

  }
}

// Scrolls to the learn more section of the page
var learnMoreButton = document.querySelector('.js-learn-more-button');
var learnMoreScroll = document.querySelector('.js-learn-more-scroll');
learnMoreButton.addEventListener('click', () => {
  let header = document.getElementById('shopify-section-header').getBoundingClientRect();
  let headerHeight = header.bottom - header.top;
  let yOffset = learnMoreScroll.getBoundingClientRect().top + window.scrollY - headerHeight;
  window.scroll({ top: yOffset, left: 0, behavior: 'smooth' });
});